<template>
  <header id="main-header" class="main-header fixed-top">
    <nav class="main-nav container navbar navbar-expand-md navbar-light flex-nowrap" :class="[{ mobileActive: navbarMobileVisible }]">
      <div class="d-flex">
        <router-link to="/" class="navbar-brand m-0 ml-3">
          <img src="@/assets/images/logo-unipar-2.png" :alt="'Logotipo ' + $store.state.websiteName" :title="$store.state.websiteName" />
        </router-link>

        <a href="" class="nav-link flags d-lg-none" @click="changeLanguage()">
          <div class="flag" :class="lang == 'pt' ? 'active' : ''">
            <img src="@/assets/images/brazil.png"  />
          </div>

          <div class="flag" :class="lang == 'es' ? 'active' : ''">
            <img src="@/assets/images/argentina.png" />
          </div>
        </a>
      </div>

      <ul class="navbar-nav d-none d-lg-flex">
        <li class="nav-item">
          <router-link to="/#vagas" class="nav-link mx-2">{{ lang == 'pt' ? 'VAGAS' : 'VACANTES' }}</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/#a-unipar" class="nav-link mx-2">UNIPAR</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/#gptw" class="nav-link mx-2">{{ lang == 'pt' ? 'CERTIFICAÇÕES' : 'CERTIFICACIONES' }}</router-link>
        </li>
      </ul>

      <ul class="navbar-nav d-none d-lg-flex">
        <li class="nav-item" v-if="!this.$store.state.user.isAuth">
          <router-link
            :to="lang == 'pt' ? '/vagas/358494-trabalhe-conosco-brasil/inscricao' : '/vagas/375953-trabaje-con-nosotros/inscricao'"
            class="btn btn-color-1 rounded-pill px-4 py-2"
          >
            {{ lang == 'pt' ? 'CADASTRAR CURRÍCULO' : 'INSCRÍBETE' }}
          </router-link>
        </li>

        <li
              class="nav-item d-none d-lg-flex"
              @click="toggleMenu"
              v-if="this.$store.state.user.isAuth"
            >
              <b-dropdown 
                size="sm"
                :text= "lang == 'pt' ? 'Acesse seu Perfil' : 'Accede a tu perfil'"
                class="btn btn-color-1 rounded-pill px-4 py-2"
                no-caret
                right
              >
                <b-dropdown-header
                  >{{ firstName }}</b-dropdown-header
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to="/meu-perfil">{{lang == 'pt' ? 'Meu Perfil' : 'Mi Perfil'}}</b-dropdown-item>
                <b-dropdown-item @click="changeModal('change-password')"
                  >{{ lang == 'pt' ? 'Mudar a senha' : 'Cambiar contraseña' }}</b-dropdown-item
                >
                <b-dropdown-item @click="signOut">{{ lang == 'pt' ? 'Sair' : 'Salir' }}</b-dropdown-item>
              </b-dropdown>
            </li>

        <span class="divider-v"></span>

        <li class="nav-item">
          <a :href="lang == 'pt' ? 'https://www.facebook.com/grupounipar/?locale=pt_BR' : 'https://www.facebook.com/GrupoUniparLatam/?locale=pt_BR'" target="_blank" class="nav-link">
            <facebook-icon />
          </a>
        </li>

        <li class="nav-item">
          <a :href="lang == 'pt' ? 'https://www.instagram.com/grupounipar' : 'https://www.instagram.com/grupouniparlatam/'" target="_blank" class="nav-link">
            <instagram-icon />
          </a>
        </li>

        <li class="nav-item">
          <a :href="lang == 'pt' ? 'https://www.youtube.com/@grupounipar' : 'https://www.youtube.com/@grupounipar'" target="_blank" class="nav-link">
            <youtube-icon style="font-size: 18px" />
          </a>
        </li>

        <li class="nav-item">
          <a href="" class="nav-link flags" @click="changeLanguage()">
            <div class="flag" :class="lang == 'pt' ? 'active' : ''">
              <img src="@/assets/images/brazil.png"  />
            </div>

            <div class="flag" :class="lang == 'es' ? 'active' : ''">
              <img src="@/assets/images/argentina.png" />
            </div>
          </a>
        </li>
      </ul>

      <button class="hamburger hamburger--slider navbar-toggle mr-3 d-lg-none d-xm-block" type="button" :class="{ 'is-active': navbarMobileVisible }" @click="toggleMenu">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <!-- <span class="navbar-mobile-bg" @click="toggleMenu"></span> -->

      <ul class="navbar-nav navbar-mobile d-flex d-lg-none">
        <li class="nav-item mb-3" v-if="!this.$store.state.user.isAuth">
          <router-link
            :to="lang == 'pt' ? '/vagas/358494-trabalhe-conosco-brasil/inscricao' : '/vagas/375953-trabaje-con-nosotros/inscricao'"
            class="btn btn-color-1 rounded-pill px-4 py-2"
          >
            {{ lang == 'pt' ? 'CADASTRAR CURRÍCULO' : 'INSCRÍBETE' }}
          </router-link>
        </li>

        <li class="nav-item" v-else>
          <a href="#" class="btn btn-color-1 rounded-pill" @click="signOut">{{ lang == 'pt' ? 'SAIR' : 'SALIR' }}</a>
        </li>

        <li class="nav-item " @click="toggleMenu">
          <router-link to="/#vagas" class="nav-link ">{{ lang == 'pt' ? 'VAGAS' : 'EMPLEOS' }}</router-link>
        </li>
        <li class="nav-item " @click="toggleMenu">
          <router-link to="/#a-unipar" class="nav-link ">A UNIPAR</router-link>
        </li>
        <li class="nav-item " @click="toggleMenu">
          <router-link to="/#gptw" class="nav-link ">{{ lang == 'pt' ? 'CERTIFICAÇÕES' : 'CERTIFICACIONES' }}</router-link>
        </li>
        <li class="nav-item " @click="toggleMenu" v-if="this.$store.state.user.isAuth">
          <router-link to="/meu-perfil" class="nav-link ">{{ lang == 'pt' ? 'MEU PERFIL' : 'MI PERFIL' }}</router-link>
        </li>
        <li class="nav-item text-center" @click="changeModal('change-password')" v-if="this.$store.state.user.isAuth">
          <router-link to=""  class="nav-link ">{{ lang == 'pt' ? 'MUDAR A SENHA' : 'CAMBIAR '+'CONTRASEÑA' }}</router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
  import FacebookIcon from "vue-material-design-icons/Facebook.vue";
  import InstagramIcon from "vue-material-design-icons/Instagram.vue";
  import YoutubeIcon from "vue-material-design-icons/Youtube.vue";

  export default {
    name: "mainHeader",

    components: {
      FacebookIcon,
      InstagramIcon,
      YoutubeIcon,
    },

    data() {
      return {
        primaryBackground: false,
        scrolled: false,
        isTop: false,
        navbarMobileVisible: false,
      };
    },

    computed: {
      firstName() {
        if(this.$store.state.user){
          const profile = this.$store.state.user.profile;
          const socialName = profile.socialName;
          const name = profile.name.split(' ')[0];
          if(socialName){
            return socialName;
          } else if(window.signUp){
            return null
          } else if(name){
            return name;
          }
        }

        return null;
      },

      avatar() {
        return this.$store.state.user.profile.avatar;
      },

      lang(){
        return localStorage.getItem('lang') || 'pt';
      }
    },

    mounted() {
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll);
    },

    watch: {
      $route(to, from) {
        this.handleScroll();
      },
    },

    methods: {

      signOut() {
        this.$store.dispatch("user/signOut");
        if (this.$route.meta.requiresAuth) this.$router.push("/");
      },

      handleScroll(event) {
        let routeName = this.$route.name;
        let scrolledAfter = 150;
        let scrollY = window.scrollY || window.pageYOffset;
        this.scrolled =
          scrollY > scrolledAfter ||
          routeName == "job" ||
          routeName == "ficha" ||
          routeName == "testes" ||
          routeName == "capa-teste" ||
          routeName == "teste" ||
          routeName == "pending-tests" ||
          routeName == "terms";

        this.isTop =
          scrollY < 30 &&
          !(
            routeName == "ficha" ||
            routeName == "testes" ||
            routeName == "capa-teste" ||
            routeName == "teste"
          );
      },

      signOut() {
        this.$store.dispatch("user/signOut");
        if (this.$route.meta.requiresAuth) this.$router.push("/");
      },

      toggleMenu() {
        this.navbarMobileVisible = !this.navbarMobileVisible;
      },

      changeModal(target) {
        this.$store.commit("DEVISE_FORM", target);
      },

      changeLanguage() {
        var currentLang = localStorage.getItem('lang')

        localStorage.setItem('lang', currentLang == 'pt' ? 'es' : 'pt');
        this.$router.push('/');
      }
    },
  };
</script>

<style lang="scss" scoped>
  .main-header{
    position: sticky;
    background-color: #fff;
  }

  /deep/.btn-secondary{
    border: none !important;
  }

  .main-nav{
    padding: 10px 0;
    justify-content: space-between;

    &.mobileActive {
      .navbar-mobile {
        transform: translateX(0vw);
      }

      .navbar-mobile-bg {
        opacity: 1;
        visibility: visible;
        display: block;
      }
    }
  }

  .navbar-brand{
    img{
      max-height: 50px;
    }
  }

  .btn{
    font-size: 12px;
    border: none;
  }

  .divider-v{
    width: 1px;
    border-left: 1px solid #ccc;
    margin: 0 15px;
  }

  .navbar-mobile-bg {
    display: none;
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in-out .1s, visibility .01s linear;
  }

  .navbar-mobile {
    padding: 25px;
    flex-direction: column !important;
    width: 290px;
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
    background: #fff;
    z-index: 10;
    transform: translateX(100vw);
    transition: transform 0.3s ease-in-out;

    .nav-item {
      .btn{
        width: 100%;
      }

      .nav-link {
        font-size: 18px;
        font-weight: 500;
        color: $body-color;
        padding: 15px;
        text-transform: capitalize;
      }
    }
  }

  .nav-item{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-link {
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .flags{
    display: flex;
    gap: 6px;

    .flag{
      border-bottom: 2px solid transparent;
      padding: 2px;

      &:hover{
        img{
          opacity: 1;
        }
      }

      img{
        height: 18px;
        opacity: 0.3;
      }

      &.active{
        border-color: theme-color('color-1');

        img{
          opacity: 1;
        }
      }
    }
  }

  li{
    button{
      border: none;
    }
  }
</style>
